import React from 'react';
import './TermsOfUse.css';

function TermsOfUse() {
  return (
    <div className="terms-container">
      <h1>TERMOS DE USO E POLÍTICA DE PRIVACIDADE</h1>
      <p>
        Olá Usuário! Bem-vindo à nossa Política de Privacidade e Termos de Uso do
        aplicativo <strong>ApoloApp</strong>. Nosso aplicativo é distribuído por
        <strong> SOLVE LIGHT DESENVOLVIMENTO DE SOFTWARE</strong>, inscrita no CNPJ n.
        34.283.610/0001-61.
      </p>
      <p>
        Aos usuários do aplicativo <strong>ApoloApp</strong>, agora, vamos lhe
        apresentar como nosso aplicativo utiliza, coleta, armazena, trata e descarta
        os seus dados pessoais, sempre prezando pela segurança e proteção dos seus
        dados pessoais.
      </p>
      <h2>1. INTRODUÇÃO</h2>
      <p>
        Nosso objetivo é proteger os seus dados pessoais e para isso seguimos todas
        as orientações da Lei Geral de Proteção de Dados (Lei n. 13.709/2018), que
        trouxe diretrizes para regulamentar as atividades de tratamento de dados
        pessoais.
      </p>
      <p>
        Para sua melhor compreensão desta Política de Privacidade, vamos lhe apresentar
        os conceitos principais:
      </p>
      <p>
        <strong>Dado Pessoal:</strong> informação relacionada a pessoa natural
        identificada ou identificável.
      </p>
      <p>
        <strong>Dado Pessoal Sensível:</strong> dado pessoal sobre origem racial ou
        étnica, convicção religiosa, opinião política, filiação a sindicato ou a
        organização de caráter religioso, filosófico ou político, dado referente à saúde
        ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa
        natural.
      </p>
      <p>
        <strong>Titular:</strong> pessoa natural a quem se referem os dados pessoais
        que são objeto de tratamento.
      </p>
      <p>
        <strong>Tratamento de Dados:</strong> é toda operação realizada com dados
        pessoais, como as que se referem a coleta, produção, recepção, classificação,
        utilização, acesso, reprodução, transmissão, distribuição, processamento,
        arquivamento, armazenamento, eliminação, avaliação ou controle da informação,
        modificação, comunicação, transferência, difusão ou extração.
      </p>
      <p>
        <strong>Compartilhamento de Dados:</strong> é a comunicação, difusão,
        transferência internacional, interconexão de dados pessoais ou tratamento
        compartilhado de bancos de dados pessoais por órgãos e entidades públicos no
        cumprimento de suas competências legais, ou entre esses e entes privados,
        reciprocamente, com autorização específica, para uma ou mais modalidades de
        tratamento permitidas por esses entes públicos, ou entre entes privados.
      </p>
      <p>
        <strong>Criação de Perfis:</strong> formas de tratamento automatizado de dados
        pessoais, onde os dados são utilizados para analisar ou prever determinados
        aspectos pessoais, tais como: situação econômica, saúde, preferências, interesses
        e comportamentos pessoais.
      </p>
      <p>
        <strong>Parceiros:</strong> terceiros que nos fornecem listas de contato para
        efeitos de marketing.
      </p>
      <p>
        <strong>Controlador:</strong> pessoa natural ou jurídica, de direito público ou
        privado, a quem competem as decisões referentes ao tratamento de dados pessoais.
      </p>
      <p>
        <strong>Operador:</strong> pessoa natural ou jurídica, de direito público ou
        privado, que realiza o tratamento de dados pessoais em nome do controlador.
      </p>
      <h2>2. A QUEM SE APLICA NOSSA POLÍTICA DE PRIVACIDADE</h2>
      <p>
        Nossa Política de Privacidade e Termos de Uso é aplicável àqueles que:
      </p>
      <p>
        a) Acessam a nossa plataforma, seja por cadastro próprio ou através de
        profissional que utiliza nossa plataforma para automatizar atendimentos;
      </p>
      <p>
        b) Se cadastram no nosso aplicativo e/ou fornecem seus dados pessoais ao
        profissional que realiza o cadastro no aplicativo;
      </p>
      <p>
        c) De qualquer outra forma utilizam os produtos e serviços oferecidos pela
        <strong> ApoloApp</strong>.
      </p>
      <h2>3. QUAIS SÃO OS SEUS DIREITOS COMO USUÁRIO DO NOSSO APLICATIVO</h2>
      <p>
        Agora que você já conhece os principais conceitos de proteção dos dados
        pessoais, é importante ter conhecimento dos seus direitos como usuário da
        nossa plataforma.
      </p>
      <p>
        Vamos recordar dois pontos importantes:
      </p>
      <p>
        a) você é nosso usuário, ou seja, titular dos dados pessoais fornecidos no
        momento da coleta para utilização da plataforma, como: nome completo, CPF,
        e-mail e outros que se fizerem necessários
      </p>
      <p>
        b) seus dados pessoais são coletados diretamente pelo profissional que realiza
        o seu cadastro como usuário em nossa plataforma.
      </p>
      <p>
        Compreendido isto, destacamos que os seus direitos quanto aos dados pessoais
        sempre estarão explícitos enquanto cliente do nosso aplicativo e do
        CONTROLADOR – profissional ao qual foram fornecidos os seus dados pessoais.
        Deixamos claro que uma vez fornecidos os dados pessoais para o uso de nossos
        produtos ou serviços, esses dados também poderão ser tratados pela empresa
        <strong> ApoloApp</strong>. Importante destacar que os direitos do titular não
        são absolutos e sempre estarão sujeitos às obrigações exigidas pela legislação
        vigente.
      </p>
      <p>
        <strong>TRANSPARÊNCIA:</strong> Você tem o direito de ser informado sobre a
        forma de como utilizamos os seus dados pessoais. Todos esses detalhes estarão
        descritos nesta Política de Privacidade.
      </p>
      <p>
        Em quais situações o acesso aos dados pode ser negado? Caso você solicite os
        seus dados pessoais, a <strong>ApoloApp</strong> fornecerá apenas suas próprias
        informações. Você poderá solicitar através do e-mail indicado do nosso
        Encarregado de Dados. Esclarecemos que não compartilhamos dados pessoais de
        outros usuários e nos reservamos a manter a confidencialidade e sigilo
        profissional se houver informações relacionadas a processos judiciais.
      </p>
      <p>
        <strong>ACESSO:</strong> A qualquer momento você pode ter acesso aos seus dados.
      </p>
      <p>
        <strong>CORREÇÃO:</strong> É seu direito solicitar, a qualquer tempo, a correção
        e/ou atualização dos seus dados pessoais, através do contato direto com o DPO
        informado ao final desta Política de Privacidade.
      </p>
      <p>
        <strong>EXCLUSÃO:</strong> Você poderá solicitar a exclusão ou remoção dos seus
        dados pessoais da base de dados da empresa <strong>ApoloApp</strong>. Porém,
        importante ressaltar que temos o direito de reter os dados caso necessário para
        o cumprimento das obrigações legais, inclusive para execução do contrato.
      </p>
      <p>
        <strong>LIMITAÇÃO AO TRATAMENTO:</strong> Na ocorrência de situações
        específicas, você terá o direito de limitar o tratamento de suas informações.
        Nestes casos, continuamos armazenando as informações, mas não as utilizaremos.
        Da mesma forma, você tem o direito de solicitar que seus dados sejam
        anonimizados, limitados ou excluídos em caso de tratamento de dados pessoais
        desnecessários, excessivos ou em violação à legislação vigente aplicável.
      </p>
      <p>
        Em caso de solicitação de limitação, nós informaremos aos nossos parceiros aos
        quais seus dados forem compartilhados sobre a limitação do tratamento.
      </p>
      <p>
        <strong>PORTABILIDADE:</strong> Você poderá solicitar a portabilidade dos seus
        dados pessoais a outro fornecedor de serviço ou produto, mediante requisição
        expressa, de acordo com a regulamentação da autoridade nacional, observados os
        segredos comercial e industrial. A portabilidade aplica-se somente aos dados que
        você nos forneceu e quando o tratamento se baseia no seu consentimento ou se
        destina à execução de contrato. Em caso de o pedido não atender aos requisitos
        mencionados, podemos recusar a portabilidade.
      </p>
      <p>
        <strong>REVOGAR O CONSENTIMENTO:</strong> O titular terá o direito de revogar o
        seu consentimento para os tratamentos que têm como embasamento legal o
        consentimento.
      </p>
      <p>
        <strong>QUANTO À TOMADA DE DECISÕES E A CRIAÇÃO DE PERFIS:</strong> Quando for
        necessário, a <strong>ApoloApp</strong> poderá utilizar ferramentas de
        automação para a tomada de decisões automatizadas relacionadas ao serviço
        contratado, ou para gerar ofertas de conteúdos de marketing. Isso quer dizer que
        poderemos assumir determinados pressupostos sobre interesses do usuário e
        utilizá-los para enviar comunicações de marketing personalizadas e assertivas.
      </p>
      <p>
        Havendo o exercício do seu direito como titular, a <strong>ApoloApp</strong>{' '}
        prioriza o retorno breve a todas as solicitações legítimas dentro de um prazo de
        15 (quinze) dias, podendo haver sinalização de prorrogação, caso a solicitação
        ou a sua resposta mostre-se complexa.
      </p>
      <p>
        Neste caso, a <strong>ApoloApp</strong> irá prontamente informá-lo e
        mantê-lo atualizado acerca do andamento de sua solicitação, sendo tais
        informações utilizadas exclusivamente para fins de verificação da sua identidade
        e armazenadas por até 5 (cinco) anos para o caso de a <strong>ApoloApp</strong>{' '}
        ter que comprovar que os direitos foram exercidos realmente por você.
      </p>
      <h2>4. QUAIS DADOS PESSOAIS SÃO COLETADOS PARA UTILIZAÇÃO DO NOSSO APLICATIVO</h2>
      <p>
        Todos os dados coletados pela <strong>ApoloApp</strong> são destinados única e
        exclusivamente para as atividades dos nossos produtos e serviços, fazendo uso
        somente das informações necessárias para o cumprimento de nossas obrigações
        legais e contratuais.
      </p>
      <p>
        Para utilizar nosso aplicativo, alguns dados pessoais serão coletados e
        poderão ser concedidos através de várias fontes, conforme segue:
      </p>
      <p>
        1. Dados pessoais fornecidos pelo usuário, podendo ser diretamente pelo
        aplicativo ou concedido ao profissional que efetua o cadastro do usuário na
        plataforma;
        <br />
        2. Dados pessoais coletados automaticamente;
        <br />
        3. Dados pessoais coletados de outras fontes.
      </p>
      <p>
        <strong>Dados pessoais que o usuário fornece diretamente:</strong> Nome completo;
        E-mail; Cadastro de Pessoa Física (CPF);
        <br />
        <strong>Dados pessoais coletados automaticamente:</strong> Dados de dispositivos
        que você usa para acessar os serviços (IP, sistema operacional, localização e
        identificador do dispositivo); Dados de navegação dos serviços (data, hora,
        funcionalidades).
        <br />
        <strong>Dados pessoais coletados de outras fontes:</strong> Dados públicos; Dados
        de perfis públicos em redes sociais; Dados de entidades de proteção ao crédito.
      </p>
      <p>
        Ainda, temos outras fontes que podemos coletar seus dados pessoais: Todos os
        dados que temos acesso foram fornecidos por você, através da utilização do
        nosso aplicativo ou pelo cadastro efetuado por profissional que utiliza nossa
        plataforma para atendimento.
      </p>
      <p>
        Podemos coletar dados pessoais em vários momentos e através de nossos canais
        de comunicação, quando:
      </p>
      <p>
        a) Solicita informações sobre, ou se propõe a contratar, um dos nossos produtos
        ou serviços através de formulários;
      </p>
      <p>
        b) Solicita suporte ao usuário e/ou realiza alguma reclamação, sugestão ou
        elogio;
      </p>
      <p>
        c) Concede o fornecimento de suas informações financeiras, se necessárias para
        cobrança e/ou proteção ao crédito.
      </p>
      <p>
        d) Solicita que um parceiro da <strong>ApoloApp</strong> o contate;
      </p>
      <p>
        e) Participa voluntariamente de ações de marketing e pesquisa da{' '}
        <strong>ApoloApp</strong>;
      </p>
      <p>
        f) Automaticamente, através da interação em nosso site, e-mail, atividades de
        navegação ou serviços;
      </p>
      <p>
        Há possibilidade de termos acesso aos seus dados pessoais, através de:
      </p>
      <p>
        a) parceiros de negócio que nos fornecem listas de marketing que incluem os seus
        dados pessoais, desde que você tenha dado seu consentimento para esta
        utilização;
        <br />
        b) bancos/instituições financeiras;
        <br />
        c) informações públicas disponíveis na internet;
        <br />
        d) Podemos verificar seus dados pessoais para nos certificarmos de que estão
        corretos ou então completá-los através de terceiros, familiares, empregadores,
        prestadores de cuidados médicos, prestadores de serviços financeiros, órgãos
        reguladores de relações de consumo, autoridades governamentais, agências
        reguladoras e agências antifraude.
      </p>
      <h2>5. QUAL A NECESSIDADE DA COLETA DOS SEUS DADOS PESSOAIS E COMO SÃO UTILIZADOS</h2>
      <p>
        Nosso objetivo ao coletar os seus dados pessoais será para a utilização dos
        serviços e/ou produtos do nosso aplicativo, podendo ser utilizado também para
        lhe oferecer produtos similares, verificar a sua identidade e cumprir obrigações
        legais.
      </p>
      <p>
        Utilizamos também para fornecer informações sobre os produtos e serviços
        oferecidos pela <strong>ApoloApp</strong>, administrar sua relação com a nossa
        empresa e ter acesso aos seus dados para quando se fizerem necessárias
        comunicações.
      </p>
      <p>
        <strong>Formas que podemos utilizar os seus dados pessoais:</strong>
      </p>
      <ul>
        <li>Analisar, avaliar e melhorar os nossos produtos e serviços aos clientes;</li>
        <li>Analisar qualquer reclamação realizada;</li>
        <li>Fornecer provas em qualquer litígio que envolva o titular e a nossa empresa;</li>
        <li>Realizar ações de marketing;</li>
        <li>Enviar notificações sobre alterações dos nossos produtos e serviços;</li>
        <li>Formar os nossos colaboradores;</li>
        <li>Monitorar a qualidade dos nossos produtos e serviços;</li>
        <li>
          Assegurar que os conteúdos do nosso site são apresentados de maneira eficaz
          para o titular e para o seu dispositivo;
        </li>
        <li>Incluir anonimamente outros dados para fins de análise e comunicação de dados;</li>
        <li>Incluir dados pessoais de outras fontes para os fins descritos nos pontos apresentados.</li>
      </ul>
      <p>
        Quando necessário, utilizaremos ferramentas tecnológicas para a tomada de
        decisões automatizadas relacionadas ao serviço contratado, nos ajudando a
        realizar tomadas de decisões adequadas e gerar ofertas de conteúdos de
        marketing. Ou seja, podemos utilizar para lhe enviar comunicações de marketing
        sobre produtos e serviços similares da <strong>ApoloApp</strong>.
      </p>
      <p>
        Em caso de não interesse no tratamento automatizado dos seus dados pessoais,
        você poderá entrar em contato com nosso DPO e solicitar a limitação da
        utilização dos dados fornecidos.
      </p>
      <p>
        Você também poderá se opor a qualquer momento à utilização de seus dados
        pessoais para efeitos de marketing direto, podendo cancelar o recebimento de
        newsletters e outras comunicações via e-mail a qualquer momento sem qualquer
        custo clicando no link “cancelar subscrição” na parte inferior da mensagem.
        Poderá também optar por não receber materiais de marketing da nossa parte nos
        contatando através dos meios de contato apresentados neste nosso Aviso de
        Privacidade.
      </p>
      <p>
        <strong>DA COLETA DE DADOS PESSOAIS SENSÍVEIS</strong>
        <br />
        O seu consentimento para tratamento de dados sensíveis será solicitado se
        formos legalmente obrigados a obtê-lo. Caso contrário, o tratamento seguirá
        nossas obrigações legais e regulatórias já definidas.
      </p>
      <p>
        Lembre-se que os seus dados pessoais são fornecidos diretamente ao profissional
        CONTROLADOR que realizará seu cadastro no nosso aplicativo. A{' '}
        <strong>ApoloApp</strong> compromete-se a proteger e assegurar que seus dados
        pessoais sensíveis estão seguros em nossa plataforma. A qualquer momento, você
        poderá negar o tratamento de dados sensíveis, porém, caso isso aconteça, não
        estaremos aptos a realizar determinadas análises e tarefas específicas, o que
        pode resultar, em alguns casos, no cancelamento do serviço contratado.
      </p>
      <h2>6. QUAL A FINALIDADE PARA O TRATAMENTO DO SEUS DADOS PESSOAIS</h2>
      <p>
        Em cumprimento à Lei Geral de Proteção de Dados, vamos te informar quais bases
        legais utilizamos para a coleta e tratamento dos seus dados pessoais:
      </p>
      <ol>
        <li>Consentimento;</li>
        <li>Cumprimento de obrigação legal ou regulatória;</li>
        <li>Execução ou criação de contrato;</li>
        <li>Tutela da saúde;</li>
        <li>Legítimo interesse;</li>
        <li>Proteção do crédito.</li>
      </ol>
      <p>
        As bases legais elencadas acima são as quais nossa empresa se qualifica para
        tratar seus dados pessoais, pois é através destas bases que indicamos a
        finalidade do dado coletado.
      </p>
      <p>
        Temos legítimo interesse em tratar os seus dados pessoais para:
      </p>
      <ul>
        <li>Subscrição e administração do serviço do titular;</li>
        <li>Ações de comunicação e marketing direto;</li>
        <li>
          Análise de dados pessoais, incluindo dados anônimos, que nos permitam
          desenvolver e direcionar o marketing dos nossos produtos e serviços;
        </li>
        <li>
          Gestão ativa sobre nossa relação com o titular, e para mantê-lo atualizado
          a respeito dos serviços;
        </li>
        <li>
          Objetivos empresariais internos, o que pode incluir continuidade da
          atividade e recuperação de catástrofe, retenção/armazenamento de
          documentos e continuidade de serviços de TI (por exemplo, backups de
          segurança e serviços de assistência), para assegurar a qualidade dos
          produtos e serviços que lhe fornecemos;
        </li>
        <li>Transações empresariais;</li>
        <li>
          Análise da carteira de clientes e estudos sobre a experiência do cliente,
          mantendo o anonimato do titular a fim de melhorar os produtos e serviços
          que oferecemos aos clientes.
        </li>
      </ul>
      <p>
        Através do seu consentimento e autorização, poderemos utilizar seus dados
        pessoais para fornecer informações sobre produtos, ofertas especiais e serviços
        que possam ser do seu interesse. Você nos concede o consentimento ao baixar
        nosso aplicativo e aceitar este Termos de Uso e Política de Privacidade.
      </p>
      <h2>8. COMO PROTEGEMOS OS SEUS DADOS PESSOAIS</h2>
      <p>
        A <strong>ApoloApp</strong> preza pela segurança e proteção dos dados pessoais
        dos usuários de seu aplicativo e aplica todos esforços para proteger de uso
        indevido, interferência, perda, acesso não autorizado, modificação ou
        divulgação.
      </p>
      <p>
        Nós implementamos medidas de segurança técnica, administrativa e física que
        nos auxiliam a proteger nossos sistemas de TI e informações, garantindo que
        estamos aptos a restaurar seus dados pessoais em caso que tenham sido
        corrompidos ou perdidos, numa situação de recuperação de desastre.
      </p>
      <p>
        As medidas de segurança empregadas pela <strong>ApoloApp</strong> incluem a
        encriptação dos dados pessoais, além da revisão e atualização regular dos nossos
        procedimentos e mecanismos de segurança para determinar a necessidade de métodos
        mais eficazes e novas tecnologias.
      </p>
      <p>
        Apesar de nossos maiores esforços, a <strong>ApoloApp</strong> informa que
        nenhuma medida de segurança é sempre perfeita ou impenetrável, não sendo possível
        garantir que nossos serviços não sejam violados.
      </p>
      <p>
        Informamos também que é dever do CONTROLADOR adotar medidas de segurança aptas
        a proteger os dados que você fornece para realizar o cadastro em nosso aplicativo
        e alimentá-lo com informações para acompanhamento!
      </p>
      <h2>9. DA TRANSFERÊNCIA INTERNACIONAL DE DADOS PESSOAIS</h2>
      <p>
        A <strong>ApoloApp</strong> armazena seus dados pessoais em nuvem, que poderão
        ser transferidos internacionalmente conforme a plataforma utilizada. As
        plataformas contratadas possuem base em outros países e, por esta razão, seus
        dados poderão ser compartilhados internacionalmente.
      </p>
      <p>
        Quando transferimos dados pessoais ou os compartilhamos com outras entidades no
        exterior, asseguramos que todas as partes concordam em protegê-los contra
        utilização indevida ou divulgação, em conformidade com a legislação vigente
        aplicável. As empresas com as quais podemos compartilhar os seus dados pessoais
        incluem outras empresas parceiras da <strong>ApoloApp</strong>, fornecedores
        de TI e outros fornecedores.
      </p>
      <h2>10. POR QUANTO TEMPO OS DADOS SÃO ARMAZENADOS</h2>
      <p>
        O tempo de armazenamento de dados pessoais durará somente enquanto forem
        necessários para cumprir as finalidades indicadas nesta Política de
        Privacidade.
      </p>
      <p>
        Enquanto o usuário estiver utilizando a plataforma, seus dados pessoais serão
        armazenados em nosso aplicativo. Em caso de dispensa do usuário, este poderá
        solicitar a exclusão de seus dados pessoais e/ou o profissional CONTROLADOR fará
        a exclusão de nossa plataforma.
      </p>
      <p>
        Após este período, a <strong>ApoloApp</strong> seguirá as determinações legais
        e regulatórias a respeito da destruição de seus dados, se reservando o direito
        de armazenar e tratar seus dados para viabilizar o exercício regular de direito.
      </p>
      <p>
        Quando continuamos a utilizar dados para fins estatísticos ou de investigação,
        os seus dados serão tratados sob anonimato para que não possam ser, em
        circunstância alguma, identificados.
      </p>
      <h2>11. DA EXCLUSÃO DOS SEUS DADOS PESSOAIS</h2>
      <p>
        Recordando os seus direitos como usuário/titular, lembre-se que você poderá
        solicitar a exclusão dos seus dados pessoais de nossa base de dados ou se opor
        ao tratamento, quando os dados pessoais já não são necessários para o objetivo
        para o qual foram originalmente coletados/tratados ou, se estivermos coletando
        dados que não sejam necessários e/ou tratando de forma que infrinja a legislação
        aplicável.
      </p>
      <p>
        Você poderá revogar o consentimento a qualquer momento. Para todas estas
        medidas, você poderá entrar em contato com nosso Encarregado de Dados.
      </p>
      <p>
        <strong>Há possibilidade de recusar pedidos de exclusão dos dados pessoais?</strong>
        <br />
        A <strong>ApoloApp</strong> reserva-se no direito de não excluir os dados
        pessoais quando tratados por motivos específicos, incluindo o cumprimento de
        obrigação legal e execução de contrato, ou para o exercício de direitos no
        âmbito de processos judiciais, administrativos ou arbitrais, seu pedido de
        exclusão pode ser negado.
      </p>
      <p>
        Acima de tudo, se tivermos que excluir os seus dados, não estaremos aptos a
        fornecer nossos produtos e serviços de forma adequada, podendo acarretar o
        cancelamento imediato de nossos serviços, sob pena de aplicação das devidas
        condições contratuais de cancelamento.
      </p>
      <p>
        Ah! E fique tranquilo, em caso de solicitação de exclusão dos dados pessoais,
        nós informamos os nossos parceiros aos quais foram transferidos seus dados
        sobre sua solicitação. Encaminharemos todas as medidas necessárias para cumprir
        com o seu pedido, mas é possível que nossos parceiros não estejam aptos a fazer
        ou garantir as devidas exclusões.
      </p>
      <h2>12. CONHEÇA NOSSO ENCARREGADO DE DADOS</h2>
      <p>
        Para tratar qualquer dúvida, esclarecimento, solicitação de exclusão, limitação
        ou revogação ao tratamento dos seus dados pessoais, você poderá conversar
        diretamente com nosso Encarregado de Dados:
      </p>
      <p>
        <strong>Nome:</strong> LUCAS TESTONI
        <br />
        <strong>E-mail:</strong> NUTRICIONISTA.LUCASTESTONI@GMAIL.COM
      </p>
      <p>
        Se houver necessidade, nós poderemos entrar em contato com você através dos
        seguintes canais:
      </p>
      <ul>
        <li>Telefone;</li>
        <li>Carta;</li>
        <li>E-mail;</li>
        <li>SMS;</li>
        <li>Aplicativos de mensagens instantâneas (Whatsapp);</li>
        <li>Outros meios eletrônicos de comunicação.</li>
      </ul>
      <h2>13. ATUALIZAÇÃO DOS TERMOS DE USO E POLÍTICA DE PRIVACIDADE</h2>
      <p>
        Reservamos o direito de atualizar esta Política de Privacidade a qualquer
        momento, para cumprir com as normas da legislação aplicável e quando ocorrer
        mudanças internas na coleta, tratamento, armazenamento e descarte dos dados
        pessoais. Quando ocorrer atualizações, você será informado através dos nossos
        canais de comunicação.
      </p>
      <p>
        <strong>Última atualização em 31 de julho de 2023.</strong>
      </p>

      {/* Botão de Concordo (opcional) */}
      <button className="agree-button">Concordo</button>
    </div>
  );
}

export default TermsOfUse;
